import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable, isDevMode} from '@angular/core';
import {Observable} from 'rxjs';
import {finalize, tap} from 'rxjs/operators';

@Injectable()
export class InterceptorSpinnerService implements HttpInterceptor {

  private count = 0;
  private msg: string;

  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> { // tslint:disable-line
    const started = Date.now();
    let ok: string;

    if (req.method === 'GET') {
      this.count++;
    }

    const handleObs: Observable<HttpEvent<any>> = next.handle(req); // tslint:disable-line
    return handleObs.pipe(tap(event => ok = (event instanceof HttpResponse) ? 'succeed' : '', error => ok = 'succeed'),
                          // Log when response observable either completes or errors
                          finalize(() => {
                            const elapsed = Date.now() - started;
                            if (req.method === 'GET') {
                              this.count--;
                              this.msg = `${req.method} '${req.urlWithParams}' ${ok} in ${elapsed} ms. / ${this.count}`;
                            } else {
                              this.msg = `${req.method} '${req.urlWithParams}' ${ok} in ${elapsed} ms.`;
                            }
                            if (isDevMode()) {
                              // TODO: remove domain from logs.
                              console.log('[INTERCEPTOR]: ', this.msg); // tslint:disable-line
                            }
                          }));
  }
}
